export default "__VITE_PUBLIC_ASSET__9b95f4d7__"